import React from 'react';
import {styled} from '@mui/material/styles';
import {COLORS} from '@fupa/fupa-uikit';
import LandingPage from './routes/LandingPage';

const Wrapper = styled('div')`
  background-color: ${COLORS.lighterGrey};
  width: 100%;
  height: 100%;
`;

function AppShell() {
  return (
    <Wrapper id='app'>
      <LandingPage />
    </Wrapper>
  );
}

export default AppShell;
